import React from "react";
import Carousel from "@gc-npm/components.carousel";
import StreamingSlide from "../streaming-slide";
import style from "./style";

const StreamingCarouse = ({ slides, taggingInfo }) => {
  return (
    <>
      <div className="streaming-carousel">
        <Carousel
          slideSeparation={8}
          arrowWidth={40}
          pointsWidth={8}
          blurColor={[11, 39, 57]}
          className="StreamingPlatform"
        >
          {slides &&
            Array.isArray(slides) &&
            slides.map((e, i) => (
              <div
                key={`slide-${i}-${e["Text-1"]["text"]}`}
              >
                <StreamingSlide
                  image={e["Image-1"]}
                  title={e["Text-1"]}
                  seriesText={e["Text-2"]}
                  suscriptionText={e["Text-3"]}
                  aditionalPriceText={e["Text-4"]}
                  postPrice={e["Text-5"]}
                  price={e["Price"]}
                  button={e["Button-1"]}
                  cardLink={e["CustomLink-1"]}
                  taggingInfo={taggingInfo}
                />
              </div>
            ))}
        </Carousel>
      </div>
      <style jsx>{style}</style>
    </>
  );
};

export default StreamingCarouse;

StreamingCarouse.propTypes = {};
StreamingCarouse.defaultProps = {};
